import { useEffect, useState } from "react";
import {
  getConsent,
  hydrateConsent,
  setConsent,
  subscribeConsent,
  subscribeConsentSettingsOpen,
  type ConsentChoice,
} from "@/lib/consent";

export type { ConsentChoice };

export function useConsent(): ConsentChoice | null {
  const [choice, setStateChoice] = useState<ConsentChoice | null>(null);
  useEffect(() => {
    hydrateConsent();
    setStateChoice(getConsent());
    return subscribeConsent(setStateChoice);
  }, []);
  return choice;
}

export function ConsentBanner() {
  const [ready, setReady] = useState(false);
  const choice = useConsent();

  useEffect(() => {
    setReady(true);
    // Reopening from the footer clears the stored choice, which shows this again.
    return subscribeConsentSettingsOpen(() => setReady(true));
  }, []);

  if (!ready || choice !== null) return null;



  return (
    <div
      role="region"
      aria-label="Analytics consent"
      className="fixed inset-x-0 bottom-0 z-[90] border-t border-frost/15 bg-midnight px-4 py-3 shadow-elevated"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-steel-on-dark">
          We measure how this site is used without cookies. Accept to allow cookies and
          session replay, which help us improve the site.
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => setConsent("denied")}
            className="min-h-[44px] rounded-full border border-frost/30 px-5 text-sm font-medium text-frost transition hover:bg-frost/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-frost"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={() => setConsent("granted")}
            className="min-h-[44px] rounded-full bg-frost px-5 text-sm font-medium text-midnight transition hover:bg-frost/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-frost"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
